import { z } from "zod";

/** Any JSON value: what a custom block's `data` returns and its component receives. */
export const stepCardJsonSchema = z.json();

export type StepCardJson = z.infer<typeof stepCardJsonSchema>;

/** The platform's own blocks (src/components/step-cards/), under the keys every customer registers them by. */
export enum StepCardBlockKey {
  FIELDS = "fields",
  DIAGNOSES = "diagnoses",
  EHR_PATIENT_CHART = "ehr_patient_chart",
  FAX_PDF = "fax_pdf",
  INSURANCE = "insurance",
  TEXT = "text",
  REFERRAL_AUTHORIZATION = "referral_authorization",
}

/** One block of a card, as the page renders it. */
export const stepCardBlockViewSchema = z.object({
  /** The registered component that renders it (configuration/step-card-blocks.ts). */
  key: z.string(),
  title: z.string().nullable(),
  /** Starts collapsed behind its title. */
  folded: z.boolean(),
  /** What the block's `data` produced from the card's saved rows; null when it failed. */
  data: stepCardJsonSchema.nullable(),
  /** The block's `data` threw or returned something that isn't JSON; only this block shows an error. */
  failed: z.boolean(),
});

export type StepCardBlockView = z.infer<typeof stepCardBlockViewSchema>;
